import React from 'react';
import { useNavigate } from 'react-router-dom';
import AdminRechargeCreditComponent from "../../../components/Admin/agencies/AdminRechargeCreditComponent";

const AdminRechargeCreditPage = () => {
    const navigate = useNavigate();

    let redirect = (paymentId) => {
        navigate('/admin/dai-ly/' + paymentId + '/hoan-thanh-yeu-cau-nap-tien.html');
    }

    return <AdminRechargeCreditComponent
        shouldRedirect={ (paymentId) => redirect(paymentId) }
    />;
}

export default AdminRechargeCreditPage;